import { ActivityLoader, Body, ContainerLogo, ContainerMain, Form, Header, LoaderContainerRow } from './style';
import { LogoIcon } from '../../assets';
import { BackButton, ButtonForm, Input } from '../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { quizCarValidation } from '../../validations';
import { Step3Props } from './types';
import { useEffect, useState } from 'react';

type FormData = {
  name: string;
  phone: string;
  option: string;
};

export default function Step2({ option, onSubmit, onBack }: Step3Props) {
  const [loading, setLoading] = useState(true);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<FormData>({
    resolver: yupResolver(quizCarValidation),
    defaultValues: {
      option: option ?? '',
      name: '',
      phone: '',
    },
    mode: 'onBlur',
  });

  const submit = (data: FormData) => {
    onSubmit(data, true);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);

  return (
    <ContainerMain>
      {onBack && <BackButton onClick={onBack} />}
      <ContainerLogo>
        <img src={LogoIcon} alt="logo" />
      </ContainerLogo>

      {loading ? (
        <LoaderContainerRow>
          <ActivityLoader />
          <p>Carregando resultados...</p>
        </LoaderContainerRow>
      ) : (
        <>
          <Header isCompact>
            <div className="info">
              <p
                style={{
                  color: '#DB3737',
                  fontSize: '24px',
                  fontWeight: 600,
                }}
              >
                Você foi selecionado!
              </p>
              <span className="center">
                Preencha suas informações e aguarde, que será enviado um SMS de
                confirmação!
              </span>
            </div>
          </Header>
          <Body>
            <Form onSubmit={handleSubmit(submit, (e) => console.log(e))}>
              <Input
                type="text"
                label="Nome completo *"
                placeholder="Insira seu nome aqui"
                {...register('name')}
                error={errors.name?.message}
              />

              <div style={{ height: '8px' }} />

              <Input
                type="tel"
                label="Digite seu telefone principal *"
                placeholder="Insira seu telefone aqui"
                {...register('phone')}
                onChange={(e) => {
                  setValue('phone', e.target.value);
                }}
                error={errors.phone?.message}
                mask="99 99999-9999"
              />

              <div className="form-group" style={{ marginTop: '20px' }}>
                <ButtonForm
                  title="VER PARCELAS"
                  type="submit"
                  onClick={handleSubmit(submit, (e) => console.log(e))}
                />
              </div>
            </Form>
          </Body>
        </>
      )}
    </ContainerMain>
  );
}
